export default __webpack_public_path__ + "static/media/case_yellow.053cf9ad.svg";